<template>
  <TrainerLayout>
    <div>
      <h3 class="py-4 font-bold text-xl">Class History</h3>
      <SessionHistoryTable :data="tableData" />
      <Pagination
        v-if="tableData.length"
        :currentPage="currentPage"
        :handlePageChange="handlePageChange"
        :totalPages="totalPages"
      />
    </div>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout";
import SessionHistoryTable from "@/components/SessionHistory";
import { mapActions, mapGetters } from "vuex";
import { Pagination } from "@/components/t-components";

export default {
  name: "SessionHistory",
  components: {
    TrainerLayout,
    SessionHistoryTable,
    Pagination,
  },
  props: {
    data: Array,
  },
  data() {
    return {
      tableData: [],
      totalPages: "",
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters(["trainerSessionView"]),
  },
  methods: {
    ...mapActions(["getTrainerSessionView"]),
    
    async handlePageChange(page) {
      this.currentPage = page;
      const query = {
        page,
      };
      this.tableData = [];
      await this.getTrainerSessionView({ id: this.$route.params.id, query });
      this.tableData = this.trainerSessionView.history.data || [];
    },
  },
  async created() {
    const query = {
      page: this.currentPage,
    };
    await this.getTrainerSessionView({ id: this.$route.params.id, query });
    this.tableData = this.trainerSessionView.history.data || [];
    this.totalPages = this.trainerSessionView.history.last_page;
  },
};
</script>